var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 192,
    viewBox: "0 0 104 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_34631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6209 0H51.79V64H52.6209V0Z",
    fill: "url(#paint0_linear_1039_34631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7748 68.5351C55.3209 68.1113 53.7839 67.857 52.2053 67.8146C52.0807 67.8146 51.9145 67.8146 51.7899 67.8146C50.3775 67.8146 48.9651 67.9841 47.6357 68.3232C47.8019 65.9073 49.7959 64.0001 52.2053 64.0001C53.4515 64.0001 54.6147 64.5087 55.4455 65.3563C56.2348 66.204 56.7333 67.306 56.7748 68.5351Z",
    fill: "url(#paint1_linear_1039_34631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5277 85.955C68.1984 84.7259 66.3291 83.8782 63.5873 83.3696C60.8456 82.861 57.1484 82.6491 52.205 82.6491C47.2616 82.6491 43.4813 82.861 40.5734 83.3696C37.6655 83.8782 35.5884 84.6835 34.0929 85.9126C34.0098 85.9974 33.9268 86.1246 33.9268 86.2517C33.9268 86.3789 33.9683 86.506 34.0514 86.5908C35.5053 87.8623 37.9563 88.5405 41.0719 88.9219C44.1875 89.3458 48.0093 89.4305 52.205 89.4305C56.4007 89.4305 60.0978 89.261 63.0888 88.8372C64.5843 88.6252 65.8721 88.3285 66.9522 87.9895C68.0323 87.608 68.9046 87.1418 69.5277 86.5908C69.6108 86.506 69.6524 86.3789 69.6524 86.2941C69.6524 86.2093 69.6108 86.0398 69.5277 85.955ZM68.9046 86.506C66.4121 88.4133 60.1809 89.0067 52.205 89.0067C44.1459 89.0067 37.5409 88.6252 34.6745 86.506C34.5499 86.4213 34.4253 86.3365 34.3422 86.2517C34.4668 86.167 34.5499 86.0822 34.6745 85.9974C37.6239 83.8782 42.7335 83.0729 52.205 83.0729C61.6764 83.0729 66.3706 83.8358 68.9462 85.955C69.0708 86.0398 69.1539 86.1246 69.2785 86.2517C69.1539 86.3365 69.0293 86.4213 68.9046 86.506Z",
    fill: "#3884FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.302 189.033L68.6831 82.6491L35.1059 82.8682L0.694466 189.033H103.302Z",
    fill: "url(#paint2_linear_1039_34631)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6524 86.0397V86.2516C69.6524 86.1245 69.6108 86.0397 69.5278 85.9549C68.1984 84.7258 66.3291 83.8781 63.5873 83.3695C60.8456 82.8609 57.1484 82.649 52.205 82.649C47.2616 82.649 43.4813 82.8609 40.5734 83.3695C37.6655 83.8781 35.5884 84.6834 34.0929 85.9125C34.0098 85.9973 33.9268 86.1245 33.9268 86.2516V86.0397C33.9268 77.4357 39.7841 70.2304 47.6354 68.3232C48.9648 67.9841 50.3356 67.8145 51.7896 67.8145C51.9142 67.8145 52.0804 67.8145 52.205 67.8145C53.7836 67.8569 55.3206 68.1112 56.7745 68.5351C59.724 69.3828 62.3411 70.9934 64.4182 73.1549C67.6584 76.4609 69.6524 80.996 69.6524 86.0397Z",
    fill: "url(#paint3_linear_1039_34631)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2376 86.2515C69.1545 86.3362 69.0299 86.421 68.9052 86.5058C66.4127 88.4131 60.1815 89.0064 52.2056 89.0064C44.1465 89.0064 37.5415 88.625 34.6751 86.5058C34.5505 86.421 34.4259 86.3362 34.3428 86.2515C34.4674 86.1667 34.5505 86.0819 34.6751 85.9972C37.6245 83.878 42.7341 83.0727 52.2056 83.0727C61.677 83.0727 66.3712 83.8356 68.9468 85.9548C69.0299 86.0819 69.1545 86.1667 69.2376 86.2515Z",
    fill: "#EDF5FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1039_34631",
    x1: 52.2055,
    y1: 0,
    x2: 52.2055,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#25346A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25346A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1039_34631",
    x1: 52.2053,
    y1: 64.0001,
    x2: 52.2053,
    y2: 68.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25346A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1039_34631",
    x1: 51.7904,
    y1: 2.96699,
    x2: 52.0066,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25346A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25346A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1039_34631",
    x1: 51.7896,
    y1: 67.8145,
    x2: 51.7896,
    y2: 86.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25346A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243762"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_34631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.607,
    height: 192,
    fill: "white",
    transform: "translate(0.695312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.adeba3682bbdc81f4f696482d93ddd39.svg";
export { ForwardRef as ReactComponent };